import {Component} from 'preact';
import Menu from '../../Menu';
import {mapRootUrl} from '@util/URLUtils';
import {isEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';
import {Button} from '@ultradent/components';
import ProductImage from '@components/common/ProductImage';
import {NavigationContext} from '@modules/ui/header/DesktopMenu';

const MegaMenu = ({menuItems = []}) =>
    <NavigationContext.Consumer>
        {({pastPurchases}) =>
            <div className="flex txt-c1 py-6 contain-content pad-content">
                <nav className="flex-1 mega-menu--nav">
                    {menuItems.map( ( {title, url, urlHash, sysId, children} ) =>
                        <div id={sysId} className="mega-menu--nav-section leading-normal mb-4">
                            <h3 className="text-base">
                                <Menu.item title={title} url={url} urlHash={urlHash}/>
                            </h3>
                            {!isEmptyOrNil( children ) &&
                                <div className="mt-0 ml-4 text-sm">
                                {children.map( mapRootUrl( {url} ) ).map( Menu.item )}
                            </div>
                            }
                        </div>
                    )}
                </nav>
                {pastPurchases.length > 0 &&
                    <div className="border-l border-solid border-grey-lighter pl-8 w-1/4">
                    <h3 className="text-lg">Recently Viewed</h3>
                        {pastPurchases.map( item =>
                                <div className="mb-4 clearfix">
                            <a href={item.url} className="float-left p-2 mr-2 block w-24">
                                <ProductImage width="96" {...item} />
                            </a>
                            <div className="leading-tight p-2 overflow-hidden">
                                <a className="block mb-4" href={item.url}>
                                    <h4 className="text-base">{item.productFamily}</h4>
                                    <p className="text-sm">{item.kitName}</p>
                                </a>
                                <Button tertiary
                                        as="a"
                                        small
                                        icon="shopping-cart"
                                        data-quick-view
                                        data-sku={item.sku}>
                                    Add to cart
                                </Button>
                            </div>
                        </div>
                        )}
                </div>
                }
            </div>
        }
    </NavigationContext.Consumer>

export default MegaMenu;